import gql from 'graphql-tag';

export const WIDGETS_QUERY = gql`
    {
        widgets {
            id
            name
            widgetKey
            description
            widgetConfig {
                id
                widgetId
                jiraServiceDeskId
                jiraIssueTypeId
            }
        }
    }
`;

export const GET_GROUPS_AND_USERS_FOR_PICKER_QUERY = gql`
    query getGroupsAndUsersForPicker($query: String!) {
        getGroupsAndUsersForPicker(query: $query) {
            groups {
                total
                header
                groups {
                    groupId
                    name
                }
            }
            users {
                total
                header
                users {
                    accountId
                    displayName
                    avatarUrl
                }
            }
        }
    }
`;

export const GET_WIDGET_PERMISSIONS_QUERY = gql`
    query getWidgetPermissions($widgetId: String!) {
        getWidgetPermissions(widgetId: $widgetId) {
            id
            userAccountId
            groupId
            scopes
            widget {
                id
            }
        }
    }
`;

export const GET_USERS_AND_GROUPS_DETAILS_QUERY = gql`
    query getUsersAndGroupsDetails($userIds: [String], $groupIds: [String]) {
        getUsersAndGroupsDetails(userIds: $userIds, groupIds: $groupIds) {
            users {
                accountId
                displayName
                avatarUrl
            }
            groups {
                groupId
                name
            }
        }
    }
`;

export const GET_USER_PERMISSIONS = gql`
    {
        getUserPermissions {
            hasAdministerPermission
            permissions {
                widget {
                    id
                }
            }
        }
    }
`;

export const NOTIFICATIONS_QUERY = gql`
    query notifications($widgetId: String!, $offset: Int, $limit: Int, $startDate: Date) {
        notifications(widgetId: $widgetId, offset: $offset, limit: $limit, startDate: $startDate)
            @connection(key: "notifications", filter: ["widgetId"]) {
            id
            title
            description
            detailDescription
            imageLink
            showDetailView
            showFeedbackVoting
            showFeedbackField
            notificationType {
                id
                name
                color
            }
            publishedAt
            createdAt
        }
    }
`;

export const NOTIFICATION_TYPES_QUERY = gql`
    query notificationTypes($offset: Int, $limit: Int, $startDate: Date) {
        notificationTypes(offset: $offset, limit: $limit, startDate: $startDate) {
            id
            name
            color
        }
    }
`;

export const SERVICE_DESK_PROJECTS = gql`
    query serviceDeskProjects {
        serviceDeskProjects {
            id
            name
            issueTypes {
                id
                name
            }
        }
    }
`;
